import React from "react";
import { Col, Row } from 'react-bootstrap';
import { GeneralInfoForm } from "components/SMSCRateManagement";


export default () => {


  return (
    <>
      <Row>
        <Col xs={12} xl={12}>
          <GeneralInfoForm />
        </Col>
      </Row>
    </>
  );
};